<div class="action-bar-container" [displayFadeInOutAnimation]="isActionBarOpen ? 'active' : 'inactive'">
  <div class="action-bar-content">
    <div class="action-bar-left">
      <button mat-icon-button (click)="closed.emit()" type="button" title="Clear Selections" nhaTest="close-action-bar">
        <mat-icon>clear</mat-icon>
      </button>
      @if (recordType !== '') {
        <div>{{ selectedCount }} {{ displayRecordType }} Selected</div>
      } @else {
        <div>{{ selectedCount }} {{ selectedCount === 1 ? 'Student' : 'Students' }} Selected</div>
      }
    </div>
    <div class="action-bar-right">
      <ng-content></ng-content>
    </div>
  </div>
</div>

